export * from './lib/desktop-app-right-sidebar-new.module';
export * from './lib/desktop-right-sidebar.component';
